<template>
    <b-modal size="xl" ref="mdlSceltaConsensi" @shown="onShown" @hide="onHide" scrollable>
        <div style="height: 100%; background-color: transparent; overflow: hidden">
            <div style="background-color: transparent; height: 50%">
                <consensi-list-component :selectable="true" ref="cmpConsensiListComponent"
                    @rowSelected="onRowSelected"></consensi-list-component>
            </div>
            <div><b-embed type="iframe" v-show="showPdf" :src="pdfViewer" allowfullscreen></b-embed></div>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import ConsensiListComponent from "./ConsensiListComponent.vue";
import toast from "../../../template/layout/utility/sa-toast.js";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    components: { ConsensiListComponent },
    data() {
        return {
            pathResource: "/consensi",
            jsonData: null,
            showPdf: false,
            pdfViewer: null,
        };
    },
    methods: {
        show() {
            this.$refs.mdlSceltaConsensi.show();
        },
        onShown() {
            this.$refs.cmpConsensiListComponent.loadData();
        },
        onRowSelected(consenso) {
            this.creaConsenso(consenso.id);
        },
        setData(jsonData) {
            this.jsonData = jsonData;
        },
        onHide() {
            console.log("on hide");

            this.showPdf = false;
            this.pdfViewer = null;
        },
        creaConsenso(idConsenso) {
            let item = {
                idConsenso: idConsenso,
                data: JSON.stringify(this.jsonData),
            };
            this.openShowModalLoading();
            axios
                .post(process.env.VUE_APP_PATH_API + this.pathResource + "/create", item)
                .then((response) => {
                    this.closeShowModalLoading();
                    toast.success("Preview Caricata con successo");
                    this.showPdf = true;
                    this.pdfViewer = "data:application/pdf;base64," + response.data.data;
                    this.show();
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    console.log("erroe");

                    if (err.response.data) {
                        this.$bvToast.toast(err.response.data.messaggio, {
                            title: "Attenzione",
                            variant: "danger",
                            solid: true,
                        });
                    }
                    console.log(err);
                });
        },
    },
};
</script>

<style></style>
